import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center py-1" }
const _hoisted_2 = { class: "v-list-item-icon" }
const _hoisted_3 = { class: "ml-2 v-list-item-content" }

import { computed } from "vue";
import palette from "@/guac-layout/styles/variables.module.scss";
import NavigationIcon from "./NavigationIcon.vue";

interface Props {
  title: string;
  idSuffix: string;
  icon: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: {
    title: {},
    idSuffix: {},
    icon: {}
  },
  setup(__props: any) {

const props = __props;

const suffix = computed(() => {
  return props.idSuffix?.toLowerCase().replace(/ /g, "-");
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
    class: "sidebar-nav-option mb-1",
    style: { color: _unref(palette).gwDarkPurple },
    link: ""
  }, { id: `layout-menu-item-${suffix.value}` }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(NavigationIcon, { icon: _ctx.icon }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_list_item_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 16, ["style"]))
}
}

})